import axios from "axios";

export default {
    ExpenseLocation:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/expenselocation/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/expenselocation/update' : '/api/humanresourcesparametersoperations/expenselocation/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/expenselocation/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/expenselocation/select/list`)
            return response
        }
    },
    SizeInformation:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/sizeinformation/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/sizeinformation/update' : '/api/humanresourcesparametersoperations/sizeinformation/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/sizeinformation/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/sizeinformation/select/list`)
            return response
        }
    },
    SizeInformationParameter:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/paramsofsizeinformation/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/paramsofsizeinformation/update' : '/api/humanresourcesparametersoperations/paramsofsizeinformation/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/paramsofsizeinformation/delete/${data}`)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/paramsofsizeinformation/select/list/${data}`)
            return response
        }
    },
    Bank:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/bank/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/bank/update' : '/api/humanresourcesparametersoperations/bank/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/bank/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/bank/select/list`)
            return response
        },
        async ListDescriptionTypes(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/bank/descriptiontypes/select/list`)
            return response
        }
    },
    TaskArea:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/taskarea/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/taskarea/update' : '/api/humanresourcesparametersoperations/taskarea/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/taskarea/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/taskarea/select/list`)
            return response
        }
    },
    BankBrach:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/bankbranch/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/bankbranch/update' : '/api/humanresourcesparametersoperations/bankbranch/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/bankbranch/delete/${data}`)
            return response
        },
        async List(id){
            const response = await axios.get(`/api/humanresourcesparametersoperations/bankbranch/select/list/${id}`)
            return response
        }
    },
    EmployeeProficiency:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employeeproficiency/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/employeeproficiency/update' : '/api/humanresourcesparametersoperations/employeeproficiency/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employeeproficiency/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employeeproficiency/select/list`)
            return response
        }
    },
    EmployeeProficiencyParameter:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/paramsofemployeeproficiency/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/paramsofemployeeproficiency/update' : '/api/humanresourcesparametersoperations/paramsofemployeeproficiency/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/paramsofemployeeproficiency/delete/${data}`)
            return response
        }
    },
    EmployeeDepartment:{
        async TreeList(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employeedepartment/list/tree`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/employeedepartment/update' : '/api/humanresourcesparametersoperations/employeedepartment/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employeedepartment/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employeedepartment/list/select`)
            return response
        },
    },
    EmployeeDepartmentTitle:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/employeedepartmenttitle/update' : '/api/humanresourcesparametersoperations/employeedepartmenttitle/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employeedepartmenttitle/delete/${data}`)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employeedepartmenttitle/select/list/${data}`)
            return response
        },
        async ListAll(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employeedepartmenttitle/list/select`)
            return response
        }
    },
    PersonalProtectiveEquipment:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/ppe/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/ppe/update' : '/api/humanresourcesparametersoperations/ppe/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/ppe/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/ppe/select/list`)
            return response
        }
    },
    SalaryEffect:{
        Type:{
            async Table(data){
                const response = await axios.post(`/api/humanresourcesparametersoperations/salaryeffect/type/table`,data)
                return response
            },
            async CreateOrUpdate(update,data){
                const response = await axios.post(update ? '/api/humanresourcesparametersoperations/salaryeffect/type/update' : '/api/humanresourcesparametersoperations/salaryeffect/type/create',data)
                return response
            },
            async Delete(data){
                const response = await axios.post(`/api/humanresourcesparametersoperations/salaryeffect/type/delete/${data}`)
                return response
            },
            async List(){
                const response = await axios.get(`/api/humanresourcesparametersoperations/salaryeffect/type/select/list`)
                return response
            },
            async ListById(id){
                const response = await axios.get(`/api/humanresourcesparametersoperations/salaryeffect/type/select/list/${id}`)
                return response
            },
            async ListByBranch(id,branchId){
                const response = await axios.get(`/api/humanresourcesparametersoperations/salaryeffect/type/select/list/${id}/${branchId}`)
                return response
            },
            async ListByGroup(id){
                const response = await axios.get(`/api/humanresourcesparametersoperations/salaryeffect/type/select/list/group/${id}`)
                return response
            },
            Period:{
                async CreateOrUpdate(update,data){
                    const response = await axios.post(update ? `/api/humanresourcesparametersoperations/salaryeffect/type/period/update` : `/api/humanresourcesparametersoperations/salaryeffect/type/period/create`,data)
                    return response
                }
            }
        },
        TypeGroup:{
            async Table(data){
                const response = await axios.post(`/api/humanresourcesparametersoperations/salaryeffect/type/group/table`,data)
                return response
            },
            async CreateOrUpdate(update,data){
                const response = await axios.post(update ? '/api/humanresourcesparametersoperations/salaryeffect/type/group/update' : '/api/humanresourcesparametersoperations/salaryeffect/type/group/create',data)
                return response
            },
            async Delete(data){
                const response = await axios.post(`/api/humanresourcesparametersoperations/salaryeffect/type/group/delete/${data}`)
                return response
            },
            async List(){
                const response = await axios.get(`/api/humanresourcesparametersoperations/salaryeffect/type/group/select/list`)
                return response
            }
        }
    },
    NetsisAccountCode:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/netsispaymentaccount/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/netsispaymentaccount/update' : '/api/humanresourcesparametersoperations/netsispaymentaccount/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/netsispaymentaccount/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/netsispaymentaccount/select/list`)
            return response
        }
    },
    BonusPaymentType:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employee/salary/bonuspayment/type/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/employee/salary/bonuspayment/type/update' : '/api/humanresourcesparametersoperations/employee/salary/bonuspayment/type/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/employee/salary/bonuspayment/type/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/employee/salary/bonuspayment/type/select/list`)
            return response
        }
    },
    JobExitCause:{
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/sgk/jobexitcause/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/sgk/jobexitcause/update' : '/api/humanresourcesparametersoperations/sgk/jobexitcause/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/sgk/jobexitcause/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.post(`/api/humanresourcesparametersoperations/sgk/jobexitcause/list`)
            return response
        }
    },
    JobExitSpecialCause:{
        async TreeList(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/jobexitspecialcause/list`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/humanresourcesparametersoperations/jobexitspecialcause/update' : '/api/humanresourcesparametersoperations/jobexitspecialcause/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/jobexitspecialcause/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.post(`/api/humanresourcesparametersoperations/jobexitspecialcause/list`)
            return response
        },
        async ParentList(){
            const response = await axios.get(`/api/humanresourcesparametersoperations/jobexitspecialcause/parent/list`)
            return response
        },
        async ParentListWithSGKParameterId(sgkParameterId){
            const response = await axios.get(`/api/humanresourcesparametersoperations/jobexitspecialcause/parent/list/${sgkParameterId}`)
            return response
        },
        async ListGetById(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/jobexitspecialcause/sub/${data}`)
            return response
        },
    },
    ShiftTime:{
        async Table(data){
            const response = await axios.post('/api/humanresourcesparametersoperations/companyshifttime/paginate',data)
            return response
        },
        async Create(data){
            const response = await axios.post('/api/humanresourcesparametersoperations/companyshifttime/create',data)
            return response
        },
        async End(id,end){
            const response = await axios.post(`/api/humanresourcesparametersoperations/companyshifttime/create/${id}/${end}`)
            return response
        }
    },
    Brut:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/brutoperations/brut/update` : `/api/brutoperations/brut/create`,data)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/brutoperations/brut/table`,data)
            return response
        },
        async Get(data){
            const response = await axios.get(`/api/brutoperations/brut/get/`+data)
            return response
        },
        async Calculate(net,brutParameterId){
            const response = await axios.post(`/api/brutoperations/brut/calculate/`+net+'/'+brutParameterId)
            return response
        },
    },
    EksikGun:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/eksikgun/updatematch` : `/api/humanresourcesparametersoperations/eksikgun/creatematch`,data)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/eksikgun/listmatch`,data)
            return response
        },
    },
    SGKEksikGun:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/eksikgun/update` : `/api/humanresourcesparametersoperations/eksikgun/create`,data)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/eksikgun/list`,data)
            return response
        },
        async ListByWorkingType(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/eksikgun/list/byworkingtype/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/eksikgun/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/eksikgun/delete/${data}`)
            return response
        },
    },
    KYKM:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/kykm/update` : `/api/humanresourcesparametersoperations/kykm/create`,data)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/kykm/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/kykm/delete/${data}`)
            return response
        },
        async KindList(){
            const response = await axios.post(`/api/humanresourcesparametersoperations/kykm/kind/list`)
            return response
        },
        async SGKDayKindList(){
            const response = await axios.post(`/api/humanresourcesparametersoperations/kykm/sgkdaykind/list`)
            return response
        }
    },
    FaultTypeGroup:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/faulttype/group/update` : `/api/humanresourcesparametersoperations/faulttype/group/create`,data)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/faulttype/group/list`,data)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/faulttype/group/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/faulttype/group/delete/${data}`)
            return response
        },
    },
    AdministrativeLevelGroup:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/administrativelevel/group/update` : `/api/humanresourcesparametersoperations/administrativelevel/group/create`,data)
            return response
        },
        async List(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/group/list`,data)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/group/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/group/delete/${data}`)
            return response
        },
    },
    AdministrativeLevel:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/humanresourcesparametersoperations/administrativelevel/update` : `/api/humanresourcesparametersoperations/administrativelevel/create`,data)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/humanresourcesparametersoperations/administrativelevel/list`,data)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/delete/${data}`)
            return response
        },
        async ListByGroupId(id){
            const response = await axios.post(`/api/humanresourcesparametersoperations/administrativelevel/listbygroupid/${id}`)
            return response
        },
    },
    async MealPricesBasedByOrganisationalLocation(){
        const response = await axios.post(`/api/humanresourcesparametersoperations/mealpricesbasedbyorganisationallocation`)
        return response
    },
    async RoadPricesBasedByOrganisationalLocation(data){
        const response = await axios.post(`/api/humanresourcesparametersoperations/roadpricesbasedbyorganisationallocation`,data)
        return response
    },
    async ParametersToExpire(){
        const response = await axios.post(`/api/humanresourcesparametersoperations/ikparametersabouttoexpire`)
        return response
    },
}